<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">后台登录</h4>
                  <p>欢迎回来，请登录您的账号</p>
                </div>
                <vs-input
                  v-validate="'required|min:3'"
                  data-vv-validate-on="blur"
                  name="username"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="用户名"
                  v-model="username"
                  class="w-full no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                <vs-input
                  data-vv-validate-on="blur"
                  v-validate="'required|min:6|max:16'"
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="密码"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                <vs-input
                  data-vv-validate-on="blur"
                  v-validate="'required|min:6|max:6'"
                  type="password"
                  name="safecode"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="安全码"
                  v-model="safecode"
                  class="w-full mt-6 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('safecode') }}</span>

                <div class="my-5"></div>
                <vs-button type="border" @click="registerUser">注册</vs-button>
                <vs-button class="float-right" :disabled="!validateForm" @click="login">登录</vs-button>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      username: '',
      password: '',
      safecode: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '' && this.safecode != ''
    }
  },
  methods: {
    login() {
      const postdata = {}
      postdata.username = this.username
      postdata.password = this.password
      postdata.safecode = this.safecode
      this.$utils.post('admin-login', postdata).then(res => {
        localStorage.setItem('authKey', res)
        this.$vs.dialog({
          title: '提示',
          text: '登陆成功',
          acceptText: '确认'
        })
        setTimeout(() => this.$router.push('/'), 1500)
      })
    },

    registerUser() {
      this.$vs.dialog({
        title: '提示',
        text: '请在后台进行添加管理员的操作',
        acceptText: '确认'
      })
    }
  }
}
</script>

<style lang="scss"></style>
